<template>
	<JFlex class="s-items-center s-justify-end">
		<JFlex class="s-justify-end s-items-center">
			<!-- Buttons -->
			<Transition enter-active-class="animated fadeIn faster">
				<JBox v-if="showPreview">
					<JButton variant="default-light-sm" class="s-mr-2" @click="$emit('render:click')">
						{{ $t("templates.renderPreview") }}
					</JButton>

					<JButton variant="white-sm" class="s-mr-2" @click="isSettingsVisible = true">
						{{ $t("templates.previewSettings") }}
					</JButton>

					<JButton variant="white-sm" class="s-mr-2" @click="isDataEditorVisible = true">
						{{ $t("templates.previewData") }}
					</JButton>

					<slot name="post-buttons" />
				</JBox>
			</Transition>

			<!-- Toggle Preview -->
			<JFlex class="s-items-center">
				<JLabel class="s-mr-2 s-font-semibold s-text-sm s-text-gray-900">
					{{ $t("templates.preview") }}
				</JLabel>
				<JToggle :value="showPreview" @input="handleTogglePreview" />
			</JFlex>
		</JFlex>

		<!-- Preview Settings Modal -->
		<Portal :to="portalTo">
			<CModal :isVisible="isSettingsVisible">
				<JBox class="s-p-4">
					<JLabel class="s-font-semibold s-pb-1">{{ label }}</JLabel>
					<CCodeEditor :value="value" @input="$emit('input', $event)" />
					<JFlex class="s-justify-between s-mt-4">
						<JButton @click="isSettingsVisible = false" variant="default-light">{{ $t("templates.done") }}</JButton>
					</JFlex>
				</JBox>
			</CModal>
			<CModal :isVisible="isDataEditorVisible">
				<JBox class="s-p-4">
					<JLabel class="s-font-semibold s-pb-1">{{ mockDataLabel }}</JLabel>
					<CCodeEditor :value="mockData" @input="$emit('mockDataUpdate', $event)" />
					<JFlex class="s-justify-between s-mt-4">
						<JButton @click="isDataEditorVisible = false" variant="default-light">{{ $t("templates.done") }}</JButton>
					</JFlex>
				</JBox>
			</CModal>
		</Portal>
	</JFlex>
</template>

<script>
export default {
	props: {
		// Whether preview is visible or not, shows/hides buttons
		showPreview: {
			type: Boolean,
		},

		// GraphQL variables
		value: {
			type: String,
		},

		label: {
			type: String,
		},

		mockDataLabel: {
			type: String,
		},

		mockData: {
			type: String,
		},

		portalTo: {
			type: String,
			default: () => `layer4`,
		},
	},

	data() {
		return {
			isSettingsVisible: false,
			isDataEditorVisible: false,
		}
	},

	methods: {
		handleTogglePreview(value) {
			this.$emit("preview:toggle", value)
			if (value === true) this.$emit("preview:open")
			else this.$emit("preview:close")
		},
	},
}
</script>
